import ccsonGameConfigJson from '../../config/ccson/ccson_config.json';
import ccsonTileCountJson from '../../config/ccson/ccson_tilecount.json';
import ccsonTilemapJson from '../../config/ccson/ccson_tilemap.json';
import { TileDef, TileGameConfig } from '../tilebase/TileGameConfig';

/**
 * Load and parse ccson game config
 */

export type CcsonTileGroup =
  | 'fixed'
  | 'mini'
  | 'base'
  | 'exp1'
  | 'exp2'
  | 'castlesmini'
  | 'castles'
  | 'castlesplus'
  | 'seamini'
  | 'sea'
  | 'seaexp1'
  | 'seaexp2_starter'
  | 'seaexp2_game';

export type CcsonGameTypeDTO =
  | 'fixed'
  | 'mini'
  | 'base'
  | 'exp1'
  | 'base|base'
  | 'exp1|exp1'
  | 'exp2'
  | 'exp2|exp2'
  | 'exp1|exp2'
  | 'castlesmini'
  | 'castles'
  | 'castles|castles'
  | 'castlesplus'
  | 'seamini'
  | 'sea'
  | 'seaexp1'
  | 'seaexp2'
  | 'seaexp1|seaexp1';

const ccsonTileMap: Record<number, TileDef> = ccsonTilemapJson as Record<number, TileDef>;
export const gameConfigs = ccsonGameConfigJson as TileGameConfig[];
export const tileMapConfig = ccsonTileMap;

export function parseTileCount(tileCountJson: Record<string, string[]>) {
  const tileCount = new Map();
  Object.entries(tileCountJson).forEach(([key, value]) => {
    const tc = new Map();
    value.forEach((s) => {
      const parts = s.split(':');
      tc.set(parseInt(parts[0]), parseInt(parts[1]));
    });
    tileCount.set(key, tc);
  });
  return tileCount;
}

export const tileCountConfig = parseTileCount(ccsonTileCountJson);
